// Sentry, to the auth UI's project (tracing.autrik.com/4).

import * as Sentry from '@sentry/browser';
import type { Config } from './config';

export function initSentry(cfg: Config): void {
  if (!cfg.sentryDsn) return;
  Sentry.init({
    dsn: cfg.sentryDsn,
    environment: cfg.environment || undefined,
    release: `autrik_dji_auth_ui@${cfg.appVersion}`,
    initialScope: { tags: { page: 'ts' } },
  });
}

export function reportError(e: unknown, where: string): void {
  console.error(where, e);
  Sentry.captureException(e, { tags: { where } });
}

/** The per-start thing report: same message and context as the Flutter page's. */
export function reportThingStart(outcome: string, deviceSn: string, trace: string[]): void {
  console.info(`Thing at page start: ${outcome}\n${trace.join('\n')}`);
  Sentry.captureMessage(`thing module at page start: ${outcome}`, {
    level: 'info',
    contexts: { thing: { device_sn: deviceSn, trace } },
  });
}
